import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectResearchState = (state: RootState) => state.researchState;

export const selectResearchValue = createSelector(
  selectResearchState,
  (state) => state.researchValue
);

export const selectCitation = createSelector(selectResearchState, (state) => {
  if (
    !state.researchValue ||
    !state.researchValue?.research_object?.result?.basis
  )
    return [];
  return state.researchValue.research_object.result?.basis[0]?.citations;
});

export const selectResultContent = createSelector(
  selectResearchState,
  (state) => {
    if (!state.researchValue || !state.researchValue?.research_object?.result) {
      return null;
    }
    return state.researchValue.research_object.result?.content;
  }
);

export const selectEventLog = createSelector(selectResearchState, (state) => {
  if (!state.researchValue || !state.researchValue?.research_object?.event_log)
    return null;
  return state.researchValue.research_object.event_log;
});

export const selectIsResearchingStart = createSelector(
  selectResearchState,
  (state) => state.isResearchingStart
);

export const selectIsResearchContentExist = createSelector(
  selectResearchState,
  (state) => {
    if (
      !state?.researchValue?.research_object?.result ||
      state?.researchValue?.research_object?.result?.content === ""
    )
      return false;
    else if (state?.researchValue?.research_object?.result?.content !== "")
      return true;
    return false;
  }
);
